import { gsap } from "gsap";

const ANIMATION_START_DELAY = 3000; // Delay before the first cycle starts in milliseconds
const CYCLE_DELAY = 2000; // Delay before the next cycle starts in milliseconds
const ANIMATION_DURATION = 0.75; // Duration of each grid item's animation in seconds
const ANIMATION_OVERLAP = ANIMATION_DURATION / 1.5; // Overlap between each grid item's animation in seconds

class VerticalSeedProgram {
    constructor(el) {
        this.el = el;
        this.featuredCompanies = Array.from(this.el.querySelectorAll('.gl-featured-companies'));
        this.currentIndex = 0;
        this.isAnimating = false;

        this.init();
    }

    init() {
        if (this.featuredCompanies.length === 1) {
            return;
        }

        this.assignZIndexes();

        setTimeout(() => {
            this.cycleCompanies();
        }, ANIMATION_START_DELAY);
    }

    assignZIndexes() {
        let zIndex = this.featuredCompanies.length;
        let index = this.currentIndex;

        do {
            this.featuredCompanies[index].style.zIndex = zIndex;

            index = (index + 1) % this.featuredCompanies.length;
            zIndex--;
        } while (index !== this.currentIndex);
    }

    cycleCompanies() {
        if (this.isAnimating) return;

        this.isAnimating = true;
        const currentCompany = this.featuredCompanies[this.currentIndex];
        const gridItems = Array.from(currentCompany.querySelectorAll('.grid-item'));

        const tl = gsap.timeline({
            onComplete: () => {
                this.prepareNextCompany();
            }
        });
        gridItems.forEach((item, index) => {
            tl.fromTo(item, {
                opacity: 1
            }, {
                opacity: 0,
                duration: ANIMATION_DURATION,
            }, index !== 0 ? `-=${ANIMATION_OVERLAP}` : 0);
        });
    }

    prepareNextCompany() {
        const currentCompany = this.featuredCompanies[this.currentIndex];
        gsap.set(currentCompany.querySelectorAll('.grid-item'), { opacity: 1, immediateRender: false });
        currentCompany.style.zIndex = 0;

        this.currentIndex = (this.currentIndex + 1) % this.featuredCompanies.length;

        this.assignZIndexes();

        setTimeout(() => {
            this.isAnimating = false;
            this.cycleCompanies();
        }, CYCLE_DELAY);
    }
}

export default VerticalSeedProgram;
